import { render, staticRenderFns } from "./StatsDetaillees_Admin.vue?vue&type=template&id=64537fe8&"
import script from "./StatsDetaillees_Admin.vue?vue&type=script&lang=js&"
export * from "./StatsDetaillees_Admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports